import * as marietta from '../../..';
import { Matrix3D } from '../../../core';
import { ITEM_MODE_NO } from '../../Constants';

export default class Compass {
    rotation: number = 0;

    rotateTimer: any;

    timePassed: number;

    mtxRot: Matrix3D

    /**
     * コンストラクタ
     */
    constructor() {
      const targetItem:SVGElement = (<SVGElement>document.querySelector('#lib_compass'));
      const viewObj = (targetItem).querySelectorAll('svg > g');
      viewObj.forEach((element) => {
        element.setAttribute('id', 'compass');
        document.querySelector('#compassBox > svg').append(element);
      });

      this.mtxRot = new Matrix3D();

      // アクション（参照モードはできないようにする）
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode !== '2') {
        let ua = marietta.webcad.WebCADGlobal.userAgentManager;
        const self = this;
        if (ua.isMobile || ua.isTablet) {
          document.getElementById('compassBox').addEventListener('touchstart', self.onMouseDownMe);
        } else {
          document.getElementById('compassBox').addEventListener('mousedown', self.onMouseDownMe);

          document.getElementById('compassBox').addEventListener('contextmenu', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo === ITEM_MODE_NO.MODE_SITE_NO) {
              (<HTMLElement>document.querySelector('.compassDropdownList')).style.display = 'block';
            }

            document.addEventListener('click', () => {
              (<HTMLElement>document.querySelector('.compassDropdownList')).style.display = 'none';
            });
          });
        }
        ua = null;
      }
    }

    /**
     * マウスダウンされた
     * @param MouseEvent
     */
    onMouseDownMe = (e) => {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo !== ITEM_MODE_NO.MODE_SITE_NO) return;
      // 左クリックでない場合は、無視
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (!ua.isMobile && !ua.isTablet) {
        if (e.which !== 1) return;
      }

      if (this.rotateTimer != null) return;

      // 参照モードは回転機能を切る
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '2') return;

      e.preventDefault();
      // 回転の開始
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        document.addEventListener('mouseup', this.onMouseUpMe);
      }
      ua = null;

      this.rotateTimer = setInterval(() => this.rotateMe(), 50);
      this.timePassed = 0;
    }

    /**
     * 回転
     */
    rotateMe() {
      this.timePassed += 50;

      let sokudo: number = 1;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = 10;
      } else if (this.timePassed > 1000) {
        sokudo = 4;
      } else if (this.timePassed > 500) {
        sokudo = 2;
      }

      this.rotate(this.rotation + sokudo);
    }

    /**
     * マウスがUPされた
     */
    onMouseUpMe = (e) => {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo !== ITEM_MODE_NO.MODE_SITE_NO) return;
      // 左クリックでない場合は、無視
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (!ua.isMobile && !ua.isTablet) {
        if (e.which !== 1) return;
      }
      const self: Compass = this;
      // 参照モードは回転機能を切る
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '2') return;

      e.preventDefault();
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchend', self.onMouseUpMe);
      } else {
        document.removeEventListener('mouseup', self.onMouseUpMe);
      }
      ua = null;

      clearInterval(this.rotateTimer);
      this.rotateTimer = null;

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 回転
     * @param 回転角度（度数）
     */
    rotate(angle: number) {
      let _angle = angle;
      if (Number.isNaN(angle)) _angle = 0;
      this.rotation = _angle;
      this.updateTransforms();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (this.rotation > 360) this.rotation %= 360;
      const targetEl = document.getElementById('compassBox');
      if (targetEl) targetEl.style.transform = `rotate(${this.rotation}deg)`;
    }
}
